/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { I18nInfo } from './I18nInfo';
import {
    instanceOfI18nInfo,
    I18nInfoFromJSON,
    I18nInfoFromJSONTyped,
    I18nInfoToJSON,
} from './I18nInfo';

/**
 * @type PossibleActionDtoReason
 * 
 * @export
 */
export type PossibleActionDtoReason = I18nInfo;


export function PossibleActionDtoReasonFromJSON(json: any): PossibleActionDtoReason {
    return PossibleActionDtoReasonFromJSONTyped(json, false);
}

export function PossibleActionDtoReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): PossibleActionDtoReason {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...I18nInfoFromJSONTyped(json, true) };
    return  I18nInfoFromJSONTyped(json, true);
}

export function PossibleActionDtoReasonToJSON(value?: PossibleActionDtoReason | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfI18nInfo(value)) {
        return I18nInfoToJSON(value as I18nInfo);
    }

    return {};
}

/**
 * Check if a given object implements the PossibleActionDtoReason interface.
 */
export function instanceOfPossibleActionDtoReason(value: any): value is PossibleActionDtoReason {
    if (instanceOfI18nInfo(value)) return true;
    return false;
}

